/**
 * @prettier
 */
import cs from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './custom-text.module.scss';

function Text({ as = 'p', children, variant, color, className, ...rest }) {
  const Component = as;
  return (
    <Component
      className={cs(styles.text, className, styles[`font-${variant}`])}
      style={{ color }}
      {...rest}
    >
      {children}
    </Component>
  );
}

Text.propTypes = {
  as: PropTypes.oneOf(['p', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'i', 'label', 'li']),
  children: PropTypes.node,
  variant: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default Text;
